import axios from 'axios';
import { API_URL } from '../../../config/api';

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
  };
};

export const createEvent = async (payload) => {
  const response = await axios.post(`${API_URL}/events`, payload, { headers: getHeaders() });
  return response.data;
};

export const updateEvent = async (eventId, payload) => {
  const response = await axios.put(`${API_URL}/events/${eventId}`, payload, { headers: getHeaders() });
  return response.data;
};

export const fetchEvent = async (eventId) => {
  const response = await axios.get(`${API_URL}/events/${eventId}`, { headers: getHeaders() });
  return response.data;
};

export const fetchMyEvents = async () => {
  const response = await axios.get(`${API_URL}/events/mine`, { headers: getHeaders() });
  return response.data;
};

export const fetchEvents = async ({ channelId } = {}) => {
  const response = await axios.get(`${API_URL}/events`, {
    params: channelId ? { channelId } : {},
    headers: getHeaders(),
  });
  return response.data;
};

export const deleteEvent = async (eventId) => {
  const response = await axios.delete(`${API_URL}/events/${eventId}`, { headers: getHeaders() });
  return response.data;
};

export const cancelEvent = async (eventId) => {
  const response = await axios.post(`${API_URL}/events/${eventId}/cancel`, {}, { headers: getHeaders() });
  return response.data;
};

export const completeEvent = async (eventId) => {
  const response = await axios.post(`${API_URL}/events/${eventId}/complete`, {}, { headers: getHeaders() });
  return response.data;
};

export const closeEvent = async (eventId) => {
  const response = await axios.post(`${API_URL}/events/${eventId}/close`, {}, { headers: getHeaders() });
  return response.data;
};

export const reopenEvent = async (eventId) => {
  const response = await axios.post(`${API_URL}/events/${eventId}/reopen`, {}, { headers: getHeaders() });
  return response.data;
};

export const hideEvent = async (eventId) => {
  const response = await axios.post(`${API_URL}/events/${eventId}/hide`, {}, { headers: getHeaders() });
  return response.data;
};

export const unhideEvent = async (eventId) => {
  const response = await axios.post(`${API_URL}/events/${eventId}/unhide`, {}, { headers: getHeaders() });
  return response.data;
};

export const fetchEventActivity = async (eventId) => {
  const response = await axios.get(`${API_URL}/events/${eventId}/activity`, { headers: getHeaders() });
  return response.data;
};

export const recordEventForward = async (eventId, payload) => {
  const response = await axios.post(`${API_URL}/events/${eventId}/forwards`, payload || {}, { headers: getHeaders() });
  return response.data;
};

export const EVENTS_CHANGED_EVENT = 'workloop:events-changed';

export const notifyEventsChanged = (event, { revealList = false } = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENTS_CHANGED_EVENT, {
    detail: { event, revealList },
  }));
};

export const respondToEvent = async (eventId, payload) => {
  const response = await axios.post(`${API_URL}/events/${eventId}/responses`, payload, { headers: getHeaders() });
  const dto = response.data;
  const kind = String(payload?.response || '').toUpperCase();
  notifyEventsChanged(dto, {
    revealList: kind === 'ACCEPTED',
  });
  return dto;
};

export const cloneEvent = async (eventId) => {
  const response = await axios.post(`${API_URL}/events/${eventId}/clone`, {}, { headers: getHeaders() });
  return response.data;
};

export const fetchEventExpenses = async (eventId) => {
  const response = await axios.get(`${API_URL}/events/${eventId}/expenses`, { headers: getHeaders() });
  return response.data;
};

export const addEventExpense = async (eventId, payload) => {
  const response = await axios.post(`${API_URL}/events/${eventId}/expenses`, payload, { headers: getHeaders() });
  return response.data;
};

export const updateEventExpense = async (eventId, entryId, payload) => {
  const response = await axios.put(`${API_URL}/events/${eventId}/expenses/${entryId}`, payload, { headers: getHeaders() });
  return response.data;
};

export const deleteEventExpense = async (eventId, entryId) => {
  const response = await axios.delete(`${API_URL}/events/${eventId}/expenses/${entryId}`, { headers: getHeaders() });
  return response.data;
};
